export default "__VITE_ASSET__DqnNAONd__"